import { uniqBy } from 'lodash';

import { BadgeVariants } from '@/components/notifications/Badge/Badge';

export interface ProcessedCapability {
  id: string;
  displayName: string;
  variant: BadgeVariants;
}

function isSpecialCapability(displayName: string): boolean {
  return ['Relationship owner', 'View all clients'].includes(displayName);
}

function getCapabilityVariant(displayName: string): BadgeVariants {
  if (isSpecialCapability(displayName)) {
    return BadgeVariants.Primary;
  }

  return BadgeVariants.SecondaryOutline;
}

export function processCapabilities(
  capabilities: Array<{ id: string; displayName: string }> | null | undefined
): ProcessedCapability[] {
  if (!capabilities) return [];

  // Remove duplicates by displayName
  const uniqueCapabilities = uniqBy(capabilities, (c) => c.displayName);

  // Process each capability
  const processed = uniqueCapabilities
    .map(
      (capability): ProcessedCapability => ({
        id: capability.id,
        displayName: capability.displayName,
        variant: getCapabilityVariant(capability.displayName),
      })
    )
    .sort((a, b) => {
      const aIsSpecial = isSpecialCapability(a.displayName);
      const bIsSpecial = isSpecialCapability(b.displayName);

      if (aIsSpecial && !bIsSpecial) return 1;
      if (!aIsSpecial && bIsSpecial) return -1;

      return a.displayName.localeCompare(b.displayName);
    });

  return processed;
}
